import { FadeUp, Ribbon } from "./Reveal";
import { imgSrc } from "../context/ContentContext";

export const PageHero = ({ eyebrow, title, intro, image }) => (
  <section>
    <div className="mx-auto max-w-[1400px] px-4 pb-8 pt-10 sm:px-6">
      {eyebrow && (
        <FadeUp>
          <p
            data-testid="page-hero-eyebrow"
            className="font-display text-xs font-bold uppercase tracking-[0.2em] text-[#8E8D8A]"
          >
            {eyebrow}
          </p>
        </FadeUp>
      )}
      <FadeUp delay={0.05}>
        <h1
          data-testid="page-hero-title"
          className="mt-2 max-w-3xl font-display text-3xl font-bold uppercase leading-tight tracking-wide text-[#111111] sm:text-4xl"
        >
          {title}
        </h1>
      </FadeUp>
      {intro && (
        <FadeUp delay={0.1}>
          <p
            data-testid="page-hero-intro"
            className="mt-4 max-w-3xl text-[15px] leading-relaxed text-[#555555]"
          >
            {intro}
          </p>
        </FadeUp>
      )}
    </div>
    {image && (
      <FadeUp delay={0.1} className="mx-auto max-w-[1400px] px-4 pb-12 sm:px-6">
        <div className="relative">
          <img
            src={imgSrc(image.src)}
            alt={image.alt}
            className="h-[260px] w-full object-cover sm:h-[420px]"
            loading="eager"
          />
          {eyebrow && (
            <Ribbon className="absolute -bottom-4 left-4 hidden sm:inline-block">
              {eyebrow}
            </Ribbon>
          )}
        </div>
      </FadeUp>
    )}
  </section>
);
